<template>
  <tr class="weights-background rounded-start">
    <th class="d-flex align-items-center height-header-cell px-1">
      {{ trans('subscription.classification_config.weight') }}
    </th>
    <WeightCell
      v-for="(weight, weightIndex) in value"
      :key="weightIndex"
      class="height-cell px-1"
      :is-loading="false"
      :weight="weight"
      :weight-list="value"
      @DeleteWeight="remove"
      @EditWeight="edit"
    />
    <WeightCreateCell
      class="height-cell px-1"
      :is-loading="false"
      :weight-list="value"
      @AddWeight="add"
    />
  </tr>
</template>

<script>
import WeightCell from '@/employees/components/PreferenceConfig/Weight/WeightCell'
import WeightCreateCell from '@/employees/components/PreferenceConfig/Weight/WeightCreateCell'
export default {
  name: 'WeightRow',
  components: {
    WeightCell,
    WeightCreateCell,
  },
  props: {
    value: {
      required: true,
      type: Array,
    },
  },
  methods: {
    remove (removedWeight) {
      this.$emit('input', this.value.filter(weight => weight !== removedWeight))
    },
    edit ({ oldWeight, newWeight }) {
      this.$root.$emit('UpdateWeight', { oldWeight, newWeight })
      this.$emit('input', this.value
        .map(weight => {
          if (weight !== oldWeight) {
            return weight
          }
          return newWeight
        }))
    },
    add (weight) {
      this.$emit('input', [weight].concat(this.value).sort().reverse())
    },
  },
}
</script>

<style scoped>
.weights-background {
  background-color: rgba(0, 0, 60, 10%);
}
tr td:last-child {
  border-left: none;
  border-right: none;
  border-bottom: none;
}
</style>
